import Environment from '../../environment';
import axios from 'axios';
import {onFulfilled} from './interceptors/request';
import {handleLogout} from '@/Utils/CommonUtils';
import {useNavigation} from '@react-navigation/native';
import {ScreenName} from '@/navigators/StackConstants';

const useChatRestClient = () => {
  const navigation = useNavigation<any>();

  const ChatRestClient = axios.create({
    baseURL: Environment.CHAT_API_URL,
  });

  ChatRestClient.interceptors.request.use(onFulfilled);
  // Attaches the WAF token as an explicit header rather than relying on the
  // aws-waf-token cookie (which would need withCredentials + the backend to
  // allow credentialed CORS from every calling origin -- see AWS's guidance
  // on cross-domain fetch: https://docs.aws.amazon.com/waf/latest/developerguide/waf-js-challenge-api.html).
  // Scoped to send_otp only: that's the first WAF-gated call in the OTP
  // flow. Guarded and fails open (request proceeds untouched) since the SDK
  // script isn't loaded in every environment (e.g. local dev) and getToken()
  // can time out.
  ChatRestClient.interceptors.request.use(async config => {
    if (config.url?.includes('send_otp')) {
      try {
        const token = await window.AwsWafIntegration?.getToken();
        if (token) {
          config.headers['x-aws-waf-token'] = token;
        }
      } catch (e) {
        console.warn('AwsWafIntegration.getToken() failed', e);
      }
    }
    return config;
  });

  ChatRestClient.interceptors.response.use(
    response => {
      // If the request was made and the server responded with a status code
      // that falls out of the range of 2xx, this function will not be called.
      return response;
    },
    error => {
      // If request was sent and server responded with a status outside of the 2xx range
      if (error.response) {
        switch (error.response.status) {
          case 401:
            // Handle 401 error code.
            handleLogout(() => {
              navigation?.navigate(ScreenName?.Login);
            });
            console.error('401 Unauthorized Error');
            break;
          case 403:
            // Handle 403 error code.
            handleLogout(() => {
              navigation?.navigate(ScreenName?.Login);
            });
            console.error('403 Forbidden Error');
            break;
          default:
            break;
        }
      }
      return Promise.reject(error.response.data);
    },
  );
  return ChatRestClient;
};
export default useChatRestClient;
